"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M6 11.525v-.951h1.455V8.473c0-.562.456-1.018 1.018-1.018h2.1V6h.952v1.455h.95V6h.952v1.455h2.1c.563 0 1.019.456 1.019 1.018v2.1H18v.952h-1.454v.95H18v.952h-1.454v2.1c0 .563-.456 1.019-1.019 1.019h-2.1V18h-.952v-1.454h-.95V18h-.952v-1.454h-2.1a1.018 1.018 0 01-1.018-1.019v-2.1H6v-.952h1.455v-.95H6zm4.182 2.293h3.636v-3.636h-3.636v3.636z" }), "Specifications");
//# sourceMappingURL=Specifications.js.map